<app-section-quick-actions section="item" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Items</h1>
</header>

<app-item-grid-layout [items]="items" [itemTemplate]="iconTpl"/>
<ng-template #iconTpl let-item>
  <a class="atmos-item-grid__item atmos-tile"
     [class.is-locked]="!item.unlocked"
     [routerLink]="['/item', item.guid]"
     [skyTooltip]="item.name" [attr.aria-label]="item.name">
    <app-item-icon [item]="item" [subIcons]="SUBICONS_ALL" [opaque]="true" size="default"/>
  </a>
</ng-template>
